import { FormattedMessage } from "react-intl";
import * as yup from "yup";

yup.addMethod(
  yup.array,
  "unique",
  function (
    message,
    mapper = (a) => a.Answer?.toLowerCase() || a.Question?.toLowerCase()
  ) {
    return this.test("unique", message, function (list) {
      const newList =
        list[0]?.Answer || list[0]?.Answer === ""
          ? list.filter((a) => a.Answer !== "")
          : list[0]?.Question
          ? list
          : [];
      // console.log(newList, list);
      // console.log(
      //   newList?.length,
      //   newList.length === new Set(newList.map(mapper)).size
      // );
      return newList?.length === 0
        ? true
        : newList.length === new Set(newList.map(mapper)).size;
    });
  }
);
yup.addMethod(yup.array, "answerImageRequired", function (message) {
  return this.test("answerImageRequired", message, function (list) {
    let count = 0;
    let isValid = true;
    list?.forEach((element) => {
      if (element.AnswerImage !== "") {
        isValid = false;
        count++;
      }
    });
    if (isValid) {
      return true;
    } else {
      return count === list?.length ? true : false;
    }
  });
});

export const detailsSchema = yup.object().shape({
  Language: yup.string(),
  TrainingType: yup
    // .string()
    // .required("Training Type is required!")
    .array(
      yup.object().shape({
        Name: yup.string(),
        TypeId: yup.number(),
      })
    )
    .min(1, "Training Type is required!"),
  ShotClassName: yup
    .string()
    .trim()
    .required("Name is required!")
    .max(80, "Only 80 characters allowed!"),
  // .matches(
  //   /^[a-zA-Z0-9:_@?#|'`\]\[ ]*$/,
  //   "Only alphanumeric and special characters like ':#@?[]_`| are allowed"
  // ),
  isContentRequired: yup.boolean().notRequired(),
  // Content: yup.object().when("isContentRequired", {
  //   is: true,
  //   then: yup.object().shape({
  //     ContentValue: yup
  //       .mixed()
  //       .test("isContentValue", "Content is required!", (value) => {
  //         if (value?.length < 1) return false;
  //         return true;
  //       }),
  //     // .transform((v) => (!v ? undefined : v))
  //     // .required("Content is required!"),
  //     ContentMediaType: yup.number(),
  //     ContentMediaExtension: yup.string(),
  //   }),
  //   otherwise: yup.object().shape({
  //     ContentValue: yup.mixed(),
  //     // .transform((v) => (!v ? undefined : v))
  //     // .required("Content is required!"),
  //     ContentMediaType: yup.number(),
  //     ContentMediaExtension: yup.string(),
  //   }),
  // }),
  // Modified Content validation to be mandatory for webinar training type
  Content: yup.object().when("TrainingType", {
    is: (trainingTypeArr) => {
      return (
        Array.isArray(trainingTypeArr) &&
        trainingTypeArr.some(
          (type) =>
            (typeof type === "object" &&
              type?.Name?.toLowerCase() === "webinar") ||
            (typeof type === "string" && type.toLowerCase() === "webinar")
        )
      );
    },
    then: yup.object().shape({
      ContentValue: yup
        .mixed()
        .test(
          "isContentValue",
          "Content is mandatory for webinar training type!",
          (value) => {
            if (!value || value?.length < 1) return false;
            return true;
          }
        ),
      ContentMediaType: yup.number(),
      ContentMediaExtension: yup.string(),
    }),
    otherwise: yup.object().when("isContentRequired", {
      is: true,
      then: yup.object().shape({
        ContentValue: yup
          .mixed()
          .test("isContentValue", "Content is required!", (value) => {
            if (value?.length < 1) return false;
            return true;
          }),
        ContentMediaType: yup.number(),
        ContentMediaExtension: yup.string(),
      }),
      otherwise: yup.object().shape({
        ContentValue: yup.mixed(),
        ContentMediaType: yup.number(),
        ContentMediaExtension: yup.string(),
      }),
    }),
  }),
  ThumbnailImage: yup
    .mixed()
    .test("ThumbnailImage", "Thumbnail Image is required!", (value) => {
      if (value?.length < 1) return false;
      return true;
    }),
  // .mi,xed()
  // .transform((v) => (!v ? undefined : v))
  // .required("Thumbnail Image is required!"),
  TagsList: yup
    .array(
      yup.object().shape({
        TagName: yup.string(),
        TagValue: yup.string(),
      })
    )
    .min(1, "Tag is required!"),
  TagSearch: yup.string().notRequired(),
  // .matches(
  //   /^[A-Za-z0-9@# ]+$/,
  //   "Only alphanumeric and special characters like @# are allowed"
  // )
  // .nullable(),
  Description: yup
    .string()
    .trim()
    .required("Description is required!")
    .max(200, "Only 200 characters allowed"),
  Summary: yup
    .string()
    .trim()
    .required("Summary is required!")
    .max(500, "Only 500 characters allowed"),

  CalendarUrl: yup.mixed().when("TrainingType", {
    is: (trainingTypeArr) => {
      // Debugger to check the value of TrainingType during validation
      // eslint-disable-next-line no-debugger
      return (
        Array.isArray(trainingTypeArr) &&
        trainingTypeArr.some(
          (type) =>
            (typeof type === "object" &&
              type?.Name?.toLowerCase() === "webinar") ||
            (typeof type === "string" && type.toLowerCase() === "webinar")
        )
      );
    },
    then: yup
      .mixed()
      .required("ICS file is required for webinar training type"),
    // .test(
    //   "fileType",
    //   "Only .ics files are allowed",
    //   (value) => {
    //     // Debugger to check the value of ICS file during validation
    //     // eslint-disable-next-line no-debugger
    //     debugger;
    //     return (
    //       !value ||
    //       (typeof value === "object" &&
    //         value.name &&
    //         value.name.endsWith(".ics"))
    //     );
    //   }
    // ),
    otherwise: yup.mixed().notRequired(),
  }),
});

export const addQuizSchema = yup.object().shape({
  QuestionsList: yup
    .array()
    .of(
      yup.object().shape({
        Question: yup
          .string()
          .trim()
          .required("Question is required!")
          .max(250, "Only 250 characters allowed"),
        QuestionImage: yup.mixed().notRequired(),
        ActiveQuestionType: yup.number(),
        IsCorrect: yup
          .string()
          .required(<FormattedMessage id="PLEASE_SELECT_RIGHT_ANSWER_TEXT" />)
          .nullable(),
        // TrueOrFalse: yup.boolean().required("Answer option is required!"),
        // MultiSelect: yup.boolean().notRequired(),
        Explanation: yup
          .string()
          .notRequired()
          .max(250, "Only 250 characters allowed")
          .nullable(),
        AnswersList: yup.array().when("ActiveQuestionType", {
          is: 1,
          then: yup
            .array()
            .of(
              yup.object().shape({
                Answer: yup.string().when(["AnswerImage"], {
                  is: (AnswerImage) => !!AnswerImage,
                  then: yup
                    .string()
                    .trim()
                    .required("Answer is required!")
                    .max(60, "Only 60 characters allowed"),
                  otherwise: yup
                    .string()
                    .trim()
                    .required("Answer is required!")
                    .max(250, "Only 250 characters allowed"),
                }),
                AnswerImage: yup.mixed().notRequired(),
              })
            )
            .unique("Same choice already exists")
            .answerImageRequired("Please upload images for all choices")
            .min(2, "Please create atleast two choices"),
          otherwise: yup.array().of(
            yup.object().shape({
              Answer: yup.string(),
              AnswerImage: yup.mixed().notRequired(),
            })
          ),
        }),
      })
    )
    .unique("Same question already exists"),
  PassingMarks: yup.string().notRequired(),
});

export const basicSurveySchema = yup.object().shape({
  QuestionsList: yup
    .array()
    .of(
      yup.object().shape({
        Question: yup
          .string()
          .trim()
          .required("Question is required!")
          .max(250, "Only 250 characters allowed"),
        ActiveQuestionType: yup.number(),
        MultiSelect: yup.boolean().notRequired(),
        IsFreeFormTextBox: yup.boolean().notRequired(),
        AnswersList: yup
          .array()
          .when(["ActiveQuestionType", "IsFreeFormTextBox"], {
            is: (ActiveQuestionType, IsFreeFormTextBox) =>
              ActiveQuestionType === 1 && IsFreeFormTextBox === false,
            then: yup
              .array()
              .of(
                yup.object().shape({
                  Answer: yup
                    .string()
                    .trim()
                    .required("Answer is required!")
                    .max(250, "Only 250 characters allowed"),
                })
              )
              .min(2, "Please create atleast two choices")
              .max(5, "Maximum 5 choices allowed")
              .unique("Same choice already exists"),
            otherwise: yup.array().of(
              yup.object().shape({
                Answer: yup.string().max(250, "Only 250 characters allowed"),
              })
            ),
          }),
      })
    )
    .unique("Same question already exists"),
});

// ✅ Add new method for unique scores in score survey
// ✅ Enhanced uniqueScores method that only shows error when duplicates exist
yup.addMethod(yup.array, "uniqueScores", function (message) {
  return this.test("uniqueScores", message, function (list) {
    if (!list || list.length === 0) return true;

    // Filter out items without scores and get only valid numeric scores
    const validItems = list.filter(
      (item) => typeof item.Score === "number" && !isNaN(item.Score)
    );

    if (validItems.length === 0) return true;

    const scoresOnly = validItems.map((item) => item.Score);
    const uniqueScores = new Set(scoresOnly);

    // ✅ Only show error if there are actual duplicates
    if (scoresOnly.length !== uniqueScores.size) {
      // Find the duplicate scores for better error message
      const duplicates = scoresOnly.filter(
        (score, index, arr) => arr.indexOf(score) !== index
      );

      return this.createError({
        message: `Each answer must have a unique score`,
        path: this.path,
      });
    }

    return true;
  });
});

// ✅ Add new method for unique score bands to prevent duplicate min/max combinations
yup.addMethod(yup.array, "uniqueScoreBands", function (message) {
  return this.test("uniqueScoreBands", message, function (list) {
    if (!list || list.length === 0) return true;

    // Filter out items without valid min/max scores
    const validBands = list.filter(
      (band) =>
        typeof band.minScore === "number" &&
        typeof band.maxScore === "number" &&
        !isNaN(band.minScore) &&
        !isNaN(band.maxScore)
    );

    if (validBands.length === 0) return true;

    // Create score range combinations (minScore-maxScore)
    const scoreRanges = validBands.map(
      (band) => `${band.minScore}-${band.maxScore}`
    );
    const uniqueRanges = new Set(scoreRanges);

    // Check if there are duplicate score ranges
    if (scoreRanges.length !== uniqueRanges.size) {
      return this.createError({
        message: "Each score band must have a unique min-max range",
        path: this.path,
      });
    }

    return true;
  });
});

// ✅ Add new method for non-overlapping score bands
yup.addMethod(yup.array, "nonOverlappingScoreBands", function (message) {
  return this.test("nonOverlappingScoreBands", message, function (list) {
    if (!list || list.length === 0) return true;

    // Filter out items without valid min/max scores
    const validBands = list.filter(
      (band) =>
        typeof band.minScore === "number" &&
        typeof band.maxScore === "number" &&
        !isNaN(band.minScore) &&
        !isNaN(band.maxScore) &&
        band.minScore < band.maxScore
    );

    if (validBands.length <= 1) return true;

    // Sort bands by minScore for easier validation
    const sortedBands = [...validBands].sort((a, b) => a.minScore - b.minScore);

    // Check for overlapping ranges
    for (let i = 0; i < sortedBands.length - 1; i++) {
      const currentBand = sortedBands[i];
      const nextBand = sortedBands[i + 1];

      // Check if current band's maxScore overlaps with next band's minScore
      // For sequential ranges: current maxScore should be nextBand minScore - 1
      if (currentBand.maxScore >= nextBand.minScore) {
        return this.createError({
          message: `Score bands cannot overlap. Range ${currentBand.minScore}-${currentBand.maxScore} overlaps with ${nextBand.minScore}-${nextBand.maxScore}. Use sequential ranges like 0-10, 11-20.`,
          path: this.path,
        });
      }
    }

    return true;
  });
});

// ✅ Add new method for unique feedback messages in score bands
yup.addMethod(yup.array, "uniqueFeedbackMessages", function (message) {
  return this.test("uniqueFeedbackMessages", message, function (list) {
    if (!list || list.length === 0) return true;

    // Filter out items without feedback messages and get only valid strings
    const validFeedbacks = list.filter(
      (band) =>
        typeof band.feedbackMessage === "string" &&
        band.feedbackMessage.trim() !== ""
    );

    if (validFeedbacks.length === 0) return true;

    // Get feedback messages and normalize them (trim and lowercase for comparison)
    const feedbackMessages = validFeedbacks.map((band) =>
      band.feedbackMessage.trim().toLowerCase()
    );
    const uniqueFeedbacks = new Set(feedbackMessages);

    // Check if there are duplicate feedback messages
    if (feedbackMessages.length !== uniqueFeedbacks.size) {
      return this.createError({
        message: "Each score band must have a unique feedback message",
        path: this.path,
      });
    }

    return true;
  });
});

export const scoredSurveySchema = yup.object().shape({
  QuestionsList: yup
    .array()
    .of(
      yup.object().shape({
        Question: yup
          .string()
          .trim()
          .required("Question is required!")
          .max(250, "Only 250 characters allowed"),
        ActiveQuestionType: yup.number(),
        MultiSelect: yup.boolean().notRequired(),
        IsFreeFormTextBox: yup.boolean().notRequired(),
        AnswersList: yup
          .array()
          .of(
            yup.object().shape({
              Answer: yup
                .string()
                .trim()
                .required("Answer is required!")
                .max(250, "Only 250 characters allowed"),
              Score: yup
                .number()
                .transform((value, originalValue) => {
                  // Handle empty strings but keep valid numbers
                  if (originalValue === "" || originalValue == null) {
                    return undefined;
                  }

                  // ✅ Check if original value contains decimal point
                  const stringValue = String(originalValue).trim();
                  if (stringValue.includes(".")) {
                    // If it contains a decimal point, reject it
                    return NaN; // This will trigger typeError
                  }

                  // Convert to number and validate it's not NaN
                  const num = Number(originalValue);
                  return isNaN(num) ? undefined : num;
                })
                .typeError("Score must be a valid number")
                .integer("Score must be a whole number (no decimal)")
                .min(0, "Score must be positive")
                .max(100, "Score can be maximum 100")
                .test(
                  "no-leading-zeros",
                  "Invalid number format (no leading zeros allowed)",
                  function (value) {
                    const { originalValue } = this;

                    // Skip validation if empty or null
                    if (originalValue === "" || originalValue == null) {
                      return true;
                    }

                    const stringValue = String(originalValue).trim();

                    // ✅ Check for multiple zeros like "0000000"
                    if (stringValue.match(/^0{2,}$/)) {
                      return false;
                    }

                    // ✅ Check for leading zeros before other digits like "007"
                    if (stringValue.match(/^0+[1-9]/)) {
                      return false;
                    }

                    // ✅ Allow single "0" and valid numbers
                    return true;
                  }
                )
                .required("Score is required"),
            })
          )
          .min(2, "Please create atleast two choices")
          .max(10, "Maximum 10 choices allowed")
          .unique("Same choice already exists")
          .uniqueScores("Each answer must have a unique score"), // ✅ Add unique scores validation
      })
    )
    .unique("Same question already exists"),
  scoreBands: yup
    .array()
    .of(
      yup.object().shape({
        minScore: yup
          .number()
          .transform((value, originalValue) => {
            if (originalValue === "" || originalValue == null) {
              return undefined;
            }
            const num = Number(originalValue);
            return isNaN(num) ? undefined : num;
          })
          .typeError("Min score must be a valid number")
          .integer("Decimals are not allowed")
          .min(0, "Min score must be positive")
          .max(100, "Max score can be 100")
          .test(
            "no-leading-zeros",
            "no leading zeros, special characters allowed",
            function (value) {
              const { originalValue } = this;

              if (originalValue === "" || originalValue == null) {
                return true;
              }

              const stringValue = String(originalValue).trim();

              // ✅ Check for special characters - only digits allowed
              if (!/^\d+$/.test(stringValue)) {
                return false;
              }

              if (
                stringValue.match(/^0{2,}$/) ||
                stringValue.match(/^0+[1-9]/)
              ) {
                return false;
              }

              return true;
            }
          )
          .required("Min score is required")
          .test("min-less-than-max", "Min < Max", function (minScore) {
            const { maxScore } = this.parent;

            // Skip validation if either value is not a number
            if (typeof minScore !== "number" || typeof maxScore !== "number") {
              return true;
            }

            return minScore < maxScore;
          }),

        maxScore: yup
          .number()
          .transform((value, originalValue) => {
            if (originalValue === "" || originalValue == null) {
              return undefined;
            }
            const num = Number(originalValue);
            return isNaN(num) ? undefined : num;
          })
          .typeError("Max score must be a valid number")
          .integer("Decimals are not allowed")
          .min(0, "Max score must be positive")
          .max(100, "Max score can be 100")
          .test(
            "no-leading-zeros",
            "no leading zeros, special characters allowed",
            function (value) {
              const { originalValue } = this;

              if (originalValue === "" || originalValue == null) {
                return true;
              }

              const stringValue = String(originalValue).trim();

              // ✅ Check for special characters - only digits allowed
              if (!/^\d+$/.test(stringValue)) {
                return false;
              }

              if (
                stringValue.match(/^0{2,}$/) ||
                stringValue.match(/^0+[1-9]/)
              ) {
                return false;
              }

              return true;
            }
          )
          .required("Max score is required")
          .when("minScore", {
            is: (minScore) => typeof minScore === "number",
            then: (schema) => schema.min(yup.ref("minScore"), "Max > Min"),
          }),
        feedbackMessage: yup
          .string()
          .max(500, "Feedback message must be at most 500 characters")
          .required("Feedback message is required")
          .test(
            "no-only-spaces",
            "Feedback message cannot contain only spaces",
            function (value) {
              if (!value) return true; // Let required handle empty values

              // Check if the trimmed value has content
              return value.trim().length > 0;
            }
          ),
      })
    )
    // .min(2, "Please create atleast two Score Bands")
    .notRequired()
    .max(10, "Maximum 10 Score Bands are allowed")
    .uniqueScoreBands("Each score band must have a unique min-max range")
    .nonOverlappingScoreBands("Score bands cannot overlap")
    .uniqueFeedbackMessages(
      "Each score band must have a unique feedback message"
    ),
});

export const publishSchema = yup.object().shape({
  Preview: yup.string().notRequired(),
  OfflineShotclass: yup.boolean().notRequired(),
  QuestionJumbling: yup.boolean().notRequired(),
  ShowCorrectAnswers: yup.boolean().notRequired(),
  CanChangeAnswers: yup.boolean().notRequired(),
  IsSurveyMandatory: yup.boolean().notRequired(),
  IsVideoMandatory: yup.boolean().notRequired(),
  HasRestricted: yup.boolean().notRequired(),
  IsTrackingEnabled: yup.boolean().notRequired(),
  ShotclassTargetGroupMapping: yup.array().when("HasRestricted", {
    is: true,
    then: yup
      .array(
        yup.object().shape({
          Name: yup.string(),
          UserGroupId: yup.number(),
        })
      )
      .min(1, "Select at least One User Group to proceed")
      .max(20, "Maximum 20 User Groups allowed"),
    otherwise: yup.array(
      yup.object().shape({
        Name: yup.string(),
        UserGroupId: yup.number(),
      })
    ),
  }),
});
export const manageTranscriptionSchema = yup.object().shape({
  TransciptTagList: yup.array(
    yup.object().shape({
      section_id: yup.string(),
      section_tags: yup.string(),
      content_body: yup.string(),
    })
  ),
});
